
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "7e012399-1dd6-4da8-9e21-57630dae250a"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/app/node_modules/@ticketme/ui/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
